import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RoleService } from '../../services/role.service';
import { environment } from '../../environment/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, OnDestroy {
  private role_service = inject(RoleService);
  public translate = inject(TranslateService);

  sidebarMenu: MenuItem[] | undefined;
  languageOptions: any[] = [
    {
      label: 'Italiano',
      value: 'it', icon:
      'fi fi-it fis-3x',
      enabled: true
    },
    {
      label: 'Deutsch',
      value: 'de',
      icon: 'fi fi-de fis-3x',
      enabled: true
    }
  ];
  multiLingua = environment.multiLingua;

  changeLanguage: Subscription|undefined;

  ngOnInit(){
    this.changeLanguage = this.translate.onLangChange.subscribe(() => {
      this.createMenu();
    });
  }
  ngOnDestroy(){
    this.changeLanguage?.unsubscribe();
  }

  createMenu(){
    this.sidebarMenu = [
      {
        label: `<span class="line-height-3">${this.translate.instant('sidebar.dashboard')}</span>`,
        escape: false,
        icon: 'pi pi-th-large',
        routerLink: [''],
        routerLinkActiveOptions: { exact: true }
      },
      ...(this.role_service.isAlboOrConsultazione() ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.gestioneAlbo')}</span>`,
          escape: false,
          icon: 'pi pi-users',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.gestioneIscritti')}</span>`,
              escape: false,
              routerLink: ['gestione_albo/gestione_iscritti/iscritti'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.provvisori')}</span>`,
              escape: false,
              routerLink: ['gestione_albo/provvisori'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.societa')}</span>`,
              escape: false,
              routerLink: ['gestione_albo/stp'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.cancellati')}</span>`,
              escape: false,
              routerLink: ['gestione_albo/cancellati'],
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }
      ] : []),
      ...(this.role_service.isAlboOrisIscrizioniOrisConsultazione() ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.gestioneProvvisori')}</span>`,
          escape: false,
          icon: 'pi pi-file-edit',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.gestione')}</span>`,
              escape: false,
              routerLink: ['delibere/gestione'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.finalizzazione')}</span>`,
              escape: false,
              routerLink: ['delibere/finalizzazione'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.chiusi')}</span>`,
              escape: false,
              routerLink: ['delibere/chiuse'],
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }
      ] : []),
      ...(this.role_service.isAlboOrisIscrizioniOrisConsultazione() && environment.stampeDelibere ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.stampeDelibere')}</span>`,
          escape: false,
          icon: 'pi pi-print',
          routerLink: ['stampe_e_delibere'],
          routerLinkActiveOptions: { exact: true }
        }
      ] : []),
      ...(this.role_service.isAlboOrisIscrizioniOrisConsultazione() && environment.gestioneDomande ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.domandeIscrizione')}</span>`,
          escape: false,
          icon: 'pi pi-file-import',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.gestione')}</span>`,
              escape: false,
              routerLink: ['domande_iscrizione/gestione'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.storico')}</span>`,
              escape: false,
              routerLink: ['domande_iscrizione/storico'],
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }
      ] : []),
      ...(this.role_service.isIscrizioniOrisConsultazioneOrisDeontologico() ? [{
        label: `<span class="line-height-3">${this.translate.instant('sidebar.gestioneProcedimenti')}</span>`,
        escape: false,
        icon: 'pi pi-inbox',
        iconClass: 'text-lg mr-4 ml-3'
      }] : []),
      ...(this.role_service.isContabilitaOrConsultazione() ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.contabilita')}</span>`,
          escape: false,
          icon: 'pi pi-dollar',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.contabilitaIscritti')}</span>`,
              escape: false,
              routerLink: ['contabilita_iscritti/iscritti'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.cancellatiRadiati')}</span>`,
              escape: false,
              routerLink: ['contabilita_iscritti_cancellati/iscritti'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.contabilitaStp')}</span>`,
              escape: false,
              routerLink: ['contabilita_stp'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.speseAmministrative')}</span>`,
              escape: false,
              routerLink: ['contabilita/spese_amministrative'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.generaIUV')}</span>`,
              escape: false,
              routerLink: ['contabilita/genera_iuv'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.importaPagamenti')}</span>`,
              escape: false,
              routerLink: ['contabilita/import_pagamenti'],
              routerLinkActiveOptions: { exact: true }
            },
            (this.role_service.isContabilitaRole() ?
              {
                label: `<span class="line-height-3">${this.translate.instant('sidebar.configuraSolleciti')}</span>`,
                escape: false,
                routerLink: ['contabilita/configurazione-solleciti'],
                routerLinkActiveOptions: { exact: true }
              }
            : [])
          ]
        }
      ] : []),
      ...(this.role_service.isAlboOrConsultazione() ||  this.role_service.isContabilitaRole()? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.export')}</span>`,
          escape: false,
          icon: 'pi pi-table',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.avanzato')}</span>`,
              escape: false,
              iconClass: 'text-lg mr-4 ml-3',
              routerLink: ['export_avanzato'],
              routerLinkActiveOptions: { exact: true }
            },
            ...(this.role_service.isAlboRole() ? [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.casellario')}</span>`,
              escape: false,
              iconClass: 'text-lg mr-4 ml-3',
              routerLink: ['export_casellario'],
              routerLinkActiveOptions: { exact: true }
            }]:[])
          ]
        }
      ] : []),
      ...(this.role_service.isAlboOrConsultazione() ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.aggiornamentoNazionale')}</span>`,
          escape: false,
          icon: 'pi pi-sync',
          iconClass: 'text-lg mr-4 ml-3',
          routerLink: ['aggiornamento_nazionale'],
          routerLinkActiveOptions: { exact: true }
        }
      ] : []),
      ...(this.role_service.isIscrizioniOrConsultazione() && environment.importIscritti ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.importIscritti')}</span>`,
          escape: false,
          icon: 'pi pi-download',
          iconClass: 'text-lg mr-4 ml-3',
          routerLink: 'import_iscritti',
          routerLinkActiveOptions: { exact: true }
        },

        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.registri')}</span>`,
          escape: false,
          icon: 'pi pi-list',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.comunicazioni')}</span>`,
              escape: false,
              routerLink: ['registro-comunicazioni'],
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.pagamenti')}</span>`,
              escape: false,
              routerLink: ['registro-pagamenti'],
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }
      ] : []),
      ...(this.role_service.isConfigurazioneRole() ? [
        {
          label: `<span class="line-height-3">${this.translate.instant('sidebar.configurazione')}</span>`,
          escape: false,
          icon: 'pi pi-cog',
          items: [
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.listeValori')}</span>`,
              escape: false,
              icon: 'pi pi-list',
              iconClass: 'text-lg mr-4 ml-3',
              routerLink: 'configurazione/liste-valori',
              routerLinkActiveOptions: { exact: true }
            },
            {
              label: `<span class="line-height-3">${this.translate.instant('sidebar.competenze')}</span>`,
              escape: false,
              icon: 'pi pi-money-bill',
              iconClass: 'text-lg mr-4 ml-3',
              routerLink: 'configurazione/competenze',
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }
      ] : [])
    ]
  }

  switchLanguage(lang: string) {
    this.translate.use(lang).subscribe(() => {
      console.log(`Lingua caricata: ${lang}`);
    });
  }

}
